import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

export const ReportModelBadge = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <span className="relative inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[10px] font-semibold text-slate-500 dark:border-border dark:bg-muted/40 dark:text-slate-400">
      <Icon name="Sparkles" size={11} aria-hidden="true" />
      AI-generated content can be incorrect. Double-check important details.
    </span>
  );
};
